import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../../../assets/css/student/NgoScreen/NgoVerification.css';

const NgoVerification = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleRegisterClick = () => {
    setIsLoading(true);
    setTimeout(() => {
      navigate('/ngo-auth');
    }, 500);
  };

  const verPoints = [
    { text: 'Payments go <strong>directly to institutes</strong>, not to individuals' },
    { text: 'Donor uploads <strong>payment proof</strong> after completing transfer' },
    { text: '<strong>Admin monitors</strong> all transactions for full accountability' },
    { text: 'NGOs conduct <strong>on-ground field visits</strong> to verify every case' },
  ];

  return (
    <section className="nver-section" id="verification">
      <Container>
        <Row className="align-items-start g-5">

          {/* Left — Verification points */}
          <Col lg={7}>
            <span className="nver-section-label">How NGO Verification Works</span>
            <h2 className="nver-title">
              100% Transparent<br />Donation Process
            </h2>
            <p className="nver-desc">
              We ensure a transparent donation process where funds are given
              directly to educational institutes — every step is monitored and
              verified.
            </p>
            <div className="nver-points-list">
              {verPoints.map((point, index) => (
                <div className="nver-point" key={index}>
                  <div className="nver-check">✓</div>
                  <p
                    className="nver-point-text"
                    dangerouslySetInnerHTML={{ __html: point.text }}
                  />
                </div>
              ))}
            </div>
          </Col>

          {/* Right — Partner CTA card */}
          <Col lg={5}>
            <Card className="nver-partner-card">
              <Card.Body className="p-5">
                <h3 className="nver-partner-title">
                  Become a Verification Partner
                </h3>
                <p className="nver-partner-desc">
                  Make a difference in students' lives by joining our trusted
                  network of NGOs across Pakistan.
                </p>

                <button
                  className="nver-register-btn"
                  onClick={handleRegisterClick}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </>
                  ) : (
                    'Register as NGO'
                  )}
                </button>

                <div className="nver-quick-links-wrapper">
                  <p className="nver-quick-links-heading">Quick Links</p>
                  <div className="nver-quick-links">
                    <a href="#about"         className="nver-quick-link">About</a>
                    <a href="#how-it-works"  className="nver-quick-link">How It Works</a>
                    <a href="#categories"    className="nver-quick-link">Categories</a>
                    <a href="#verification"  className="nver-quick-link">Contact</a>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default NgoVerification;